<template>
    <div class="help-center-content">
        <h4>收益结算</h4>
        <p class="title">1.	哪里可以查看我的收益呢？</p>
        <p class="content">您可以在“主播工作台”—“收益明细”，查看您的收益。</p>
        <p class="title">2.如何提取我的收益呢？</p>
        <p class="content">提现请在V主播手机端，登录账号—我的—主播工作台—我的收益——收益中心—提现。</p>
        <p class="title">3. 提现还有手续费吗？是怎样计算的呢？</p>
        <p class="content">由于用户使用支付宝支付或微信支付时，支付宝平台或微信平台都会收取交易额的0.6%作为手续费，自2017年2月8日起，喜马拉雅FM将对支付宝和微信支付的订单扣除交易额的0.6%作为渠道成本，扣除渠道成本后的收益，平台与主播将继续按合同比例进行分成。
            <br><br>例如：单笔订单使用支付宝或微信支付100元，主播的合同分成比例为5：5。该笔订单的渠道成本为 100×0.6%=0.6元则主播收益=（100-渠道成本）×50%=49.7元微信和支付宝的渠道费将自2017年2月8日起开始扣除，苹果支付的订单不受影响。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {

    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// EarningClosing.vue?52b1d75a